import { render, staticRenderFns } from "./PostListHome.vue?vue&type=template&id=1d188faa&"
import script from "./PostListHome.vue?vue&type=script&lang=js&"
export * from "./PostListHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports